import React, { useState, useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { mediaUrl, apiCall } from "../util";
import { why_choose_section_bg, why_us } from "../Image";
import axios from "axios";

const WhyUs = () => {
  const [data, setData] = useState([]);
  const [titleData, setTitleData] = useState(null);

  useEffect(() => {
    const fetchWhyUsTitle = async () => {
      try {
        const result = await axios.get(apiCall + "why_us/getall");
        setData(result.data.filter((item) => item.isView === 1).slice(0, 6));
        const response = await axios.post(apiCall + "why_us_title/getall");
        if (response.data[0]) {
          setTitleData(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching why us title:", error);
      }
    };
    fetchWhyUsTitle();
  }, []);
  return (
    <section className="bg-white half-section pt-0">
      <div className="container">
        <div className="row -align-items-center -justify-content-center text-start">
          {/* Left Content */}
          <ScrollAnimation
            animateIn="animate__fadeInUp"
            duration={0.6}
            animateOnce={true}
            delay={0}
            className="col-xl-6 col-lg-6 md-mb-20px"
          >
            <div className="d-flex align-items-end gap-3">
              <img src={why_us} className="h-80px" alt="" />
              <div>
                <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
                  Why us?
                </span>
                <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                  Why Choose Sree Gokulam Super{" "}
                  <span className="text-gradient-sg-red-purple">
                    Speciality Hospital
                  </span>
                </h5>
              </div>
            </div>
            <p className="mt-3 text-justify">
              {titleData?.title
                ? titleData.title
                : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
            </p>

            {/* Cards Section */}
            <div className="row gy-4 gx-4">
              {data.map((data, index) => (
                <ScrollAnimation
                  key={index}
                  animateIn="animate__fadeInUp"
                  duration={0.6}
                  animateOnce={true}
                  delay={index * 150}
                  className="col-6 col-md-4"
                >
                  <div className="why_choose_card h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
                    <div className="mb-15px">
                      <img
                        src={`${mediaUrl}/${data.image}`}
                        className="h-40px object-fit-cover"
                        alt={data.title}
                      />
                    </div>
                    <h5 className="fs-16 fw-600 text-dark-gray m-0 lh-sm">
                      {data.title}
                    </h5>
                  </div>
                </ScrollAnimation>
              ))}
            </div>
          </ScrollAnimation>

          {/* Right Content */}
          <ScrollAnimation
            animateIn="animate__fadeInRight"
            duration={0.8}
            animateOnce={true}
            className="col-xl-6 col-lg-6 md-mb-20px"
          >
            <img
              src={
                titleData && titleData.image
                  ? `${mediaUrl}/${titleData.image}`
                  : { why_choose_section_bg }
              }
              alt=""
              className="sg-img-radius h-100 object-fit-cover"
            />
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;

////selfuseffect
// import React,{useEffect, useState} from "react";
// import ScrollAnimation from "react-animate-on-scroll";
// import "animate.css/animate.min.css";
// import { apiCall,mediaUrl } from "../util";
// import axios from 'axios';
// const WhyUs = () => {
//   const [data, setData] = useState([]);
//   const [titleData, setTitleData] = useState(null);
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(apiCall + "why_us/getall");
//         const filteredData = response.data.filter(item => item.isView === 1).slice(0, 6);

//       setData(filteredData);
//       // console.log(filteredData, "filteredData"); // Check the filtered data
//         const titleResponse = await axios.post(
//           apiCall + "why_us_title/getall"
//         );

//         if (titleResponse.data && titleResponse.data[0]) {
//           setTitleData(titleResponse.data[0]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   return (
//     <section className="bg-white half-section pt-0">
//       <div className="container">
//         <div className="row -align-items-center -justify-content-center text-start">
//           {/* Left Content */}
//           <ScrollAnimation
//             animateIn="animate__fadeInUp"
//             duration={0.6}
//             animateOnce={true}
//             delay={0}
//             className="col-xl-6 col-lg-6 md-mb-20px"
//           >
//             <div className="d-flex align-items-end gap-3">
//               <img
//                 src={why_us}
//                 className="h-80px"
//                 alt=""
//               />
//               <div>
//                 <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
//                   Why us?
//                 </span>
//                 <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                   Why Choose Sree Gokulam Super{" "}
//                   <span className="text-gradient-sg-red-purple">
//                     Speciality Hospital
//                   </span>
//                 </h5>
//               </div>
//             </div>
//             <p className="mt-3 text-justify" style={{textAlign:"justify"}}>
//             {titleData?.title
//                 ? titleData.title
//                 : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}

//             </p>

//             {/* Cards Section */}
//             <div className="row gy-4 gx-4">
//               {data.map((data, index) => (
//                 <ScrollAnimation
//                   key={index}
//                   animateIn="animate__fadeInUp"
//                   duration={0.6}
//                   animateOnce={true}
//                   delay={index * 150}
//                   className="col-6 col-md-4"
//                 >
//                   <div className="why_choose_card h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
//                     <div className="mb-15px">
//                       <img
//                         src={`${mediaUrl}/${data.image}`}
//                         className="h-40px object-fit-cover"
//                         alt={data.title}
//                       />
//                     </div>
//                     <h5 className="fs-16 fw-600 text-dark-gray m-0 lh-sm">
//                       {data.title}
//                     </h5>
//                   </div>
//                 </ScrollAnimation>
//               ))}
//             </div>
//           </ScrollAnimation>

//           {/* Right Content */}
//           <ScrollAnimation
//             animateIn="animate__fadeInRight"
//             duration={0.8}
//             animateOnce={true}
//             className="col-xl-6 col-lg-6 md-mb-20px"
//           >
//             <img
//               src={titleData && titleData.image ? `${mediaUrl}/${titleData.image}` : {why_choose_section_bg}}
//               alt=""
//               className="sg-img-radius h-100 object-fit-cover"
//             />
//           </ScrollAnimation>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyUs;

////animejs
// import React, { useEffect } from "react";
// import anime from "animejs";

// const WhyUs = () => {
//   useEffect(() => {
//     const elements = document.querySelectorAll("[data-anime]");
//     elements.forEach((el) => {
//       try {
//         const animeConfig = JSON.parse(el.getAttribute("data-anime"));
//         anime({
//           targets: animeConfig.el === "childs" ? el.children : el,
//           ...animeConfig,
//         });
//       } catch (error) {
//         console.error("Invalid data-anime JSON:", error);
//       }
//     });
//   }, []);

//   const features = [
//     { title: "Commitment to Excellence", img: "commitment.png" },
//     { title: "Patient-Centric Approach", img: "supporting.png" },
//     { title: "Cutting-edge Medical Equipment", img: "surgery-room.png" },
//     { title: "Affordable Healthcare", img: "affordable-healthcare.png" },
//     { title: "24/7 Emergency Care", img: "24-hours-support.png" },
//     { title: "Focus on Research and Innovation", img: "research.png" },
//   ];

//   return (
//     <section className="bg-white half-section pt-0">
//       <div className="container">
//         <div className="row -align-items-center -justify-content-center text-start">
//           <div
//             className="col-xl-6 col-lg-6 md-mb-20px"
//             data-anime='{
//               "el": "childs",
//               "translateY": [30, 0],
//               "opacity": [0, 1],
//               "duration": 600,
//               "delay": 0,
//               "staggervalue": 400,
//               "easing": "easeOutQuad"
//             }'
//           >
//             <div className="d-flex align-items-end gap-3">
//               <img
//                 src={why_us}
//                 className="h-80px"
//                 alt=""
//               />
//               <div>
//                 <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
//                   Why us?
//                 </span>
//                 <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                   Why Choose Sree Gokulam Super{" "}
//                   <span className="text-gradient-sg-red-purple">
//                     Speciality Hospital
//                   </span>
//                 </h5>
//               </div>
//             </div>
//             <p className="mt-3">
//               Lorem ipsum, dolor sit amet consectetur adipisicing elit. Facilis
//               aliquid iure et minus eos eius quia incidunt cupiditate repellat
//               tenetur, vitae provident blanditiis asperiores animi repellendus
//               nulla, laborum quis doloribus.
//             </p>
//             <div
//               className="row gy-4 gx-4"
//               data-anime='{
//                 "el": "childs",
//                 "translateY": [30, 0],
//                 "opacity": [0, 1],
//                 "duration": 600,
//                 "delay": 0,
//                 "staggervalue": 400,
//                 "easing": "easeOutQuad"
//               }'
//             >
//               {features.map((feature, index) => (
//                 <div key={index} className="col-6 col-md-4">
//                   <div className="why_choose_card h-100 text-center bg-white box-shadow-large border-radius-20px p-30px">
//                     <div className="mb-15px">
//                       <img
//                         src={`../assets/gokulam_images/icons/${feature.img}`}
//                         className="h-40px object-fit-cover"
//                         alt=""
//                       />
//                     </div>
//                     <h5 className="fs-16 fw-600 text-dark-gray m-0 lh-sm">
//                       {feature.title}
//                     </h5>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div
//             className="col-xl-6 col-lg-6 md-mb-20px"
//             data-anime='{
//               "opacity": [0, 1],
//               "duration": 1200,
//               "delay": 0,
//               "staggervalue": 150,
//               "easing": "easeOutQuad"
//             }'
//           >
//             <img
//               src={why_choose_section_bg}
//               alt=""
//               className="sg-img-radius h-100 object-fit-cover"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyUs;
